/* Rucci Forged quote block: finish picker, approximate preview, vehicle photos, quote form.
   Mirrors the Vercel catalog site (rucci-forged-wheels-catalog.vercel.app) so quotes from
   either place are identical. Vanilla JS, no dependencies. */
(function () {
  var root = document.querySelector('[data-rucci-quote]');
  if (!root) return;

  var STANDARD = ['Chrome', 'Brushed', 'Black', '18K Liquid', '18K Brushed Gold', '24K Liquid', '24K Brushed Gold'];
  var SWATCH = {
    'Chrome': 'linear-gradient(135deg,#f4f4f4 0%,#9a9a9a 45%,#e8e8e8 60%,#7a7a7a 100%)',
    'Brushed': 'linear-gradient(90deg,#b9b9b9,#d6d6d6 30%,#a8a8a8 55%,#cfcfcf)',
    'Black': 'linear-gradient(135deg,#2a2a2a,#050505)',
    '18K Liquid': 'linear-gradient(135deg,#f6dc8a,#c9961f 55%,#f2d26b)',
    '18K Brushed Gold': 'linear-gradient(90deg,#c9a24a,#e3c472 35%,#b9923c 60%,#dcbb62)',
    '24K Liquid': 'linear-gradient(135deg,#ffe28a,#e0a800 55%,#ffd75e)',
    '24K Brushed Gold': 'linear-gradient(90deg,#d8ae2e,#f0cc63 35%,#c99f27 60%,#ebc659)'
  };
  // Approximate preview tones (same numbers as the Vercel site's finishPreview.ts)
  var TONES = {
    'Chrome':           { rgb: [236, 238, 242], contrast: 1.35, gamma: 1.0,  specular: 1.0 },
    'Brushed':          { rgb: [214, 214, 210], contrast: 0.9,  gamma: 1.05, specular: 0.55 },
    'Black':            { rgb: [38, 38, 42],    contrast: 1.15, gamma: 1.25, specular: 0.45 },
    '18K Liquid':       { rgb: [238, 196, 84],  contrast: 1.2,  gamma: 1.0,  specular: 0.9 },
    '18K Brushed Gold': { rgb: [222, 182, 86],  contrast: 0.9,  gamma: 1.05, specular: 0.5 },
    '24K Liquid':       { rgb: [250, 206, 46],  contrast: 1.2,  gamma: 1.0,  specular: 0.9 },
    '24K Brushed Gold': { rgb: [236, 194, 56],  contrast: 0.9,  gamma: 1.05, specular: 0.5 }
  };

  function readJson(sel) { try { return JSON.parse((root.querySelector(sel) || {}).textContent || 'null') || []; } catch (e) { return []; } }
  var variants = readJson('[data-rq-variants]');
  var vehicles = readJson('[data-rq-vehicles]');
  var wheelName = root.dataset.wheel, catalogImage = root.dataset.image, api = root.dataset.api;

  // ---- gallery image swap -------------------------------------------------------
  function galleryImg() {
    return document.querySelector('.product__media-item.is-active .product__media img') ||
           document.querySelector('.product__media-item .product__media img') ||
           document.querySelector('.product__media img');
  }
  var saved = null, tag = null;
  function swapImage(url, label) {
    var img = galleryImg(); if (!img) return;
    if (!saved) saved = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset'), sizes: img.getAttribute('sizes') };
    img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = url;
    var box = img.closest('.product__media') || img.parentNode;
    if (!tag) { tag = document.createElement('span'); tag.className = 'rq__preview-tag'; box.appendChild(tag); }
    tag.textContent = label || '';
    if (!label) { tag.remove(); tag = null; }          // Dawn's `.media > *` would override `hidden`, so remove it outright
  }
  function restoreImage() {
    var img = galleryImg(); if (!img || !saved) return;
    if (saved.srcset) img.setAttribute('srcset', saved.srcset); if (saved.sizes) img.setAttribute('sizes', saved.sizes); img.src = saved.src;
    if (tag) { tag.remove(); tag = null; }
  }

  // ---- approximate preview (luminance-mapped recolour of the catalog photo) --------
  var cache = {};
  function approx(src, finish, cb) {
    var tone = TONES[finish]; if (!tone) return cb(null);
    var key = finish + '|' + src; if (cache[key] !== undefined) return cb(cache[key]);
    var im = new Image(); im.crossOrigin = 'anonymous';
    im.onerror = function () { cache[key] = null; cb(null); };
    im.onload = function () {
      try {
        var max = 1000, sc = Math.min(1, max / Math.max(im.naturalWidth, im.naturalHeight));
        var w = Math.round(im.naturalWidth * sc), h = Math.round(im.naturalHeight * sc);
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var ctx = c.getContext('2d', { willReadFrequently: true }); ctx.drawImage(im, 0, 0, w, h);
        var d = ctx.getImageData(0, 0, w, h), px = d.data;
        var corner = function (x, y) { var i = (y * w + x) * 4; return [px[i], px[i + 1], px[i + 2], px[i + 3]]; };
        var cs = [corner(0, 0), corner(w - 1, 0), corner(0, h - 1), corner(w - 1, h - 1)];
        var white = cs.some(function (k) { return k[3] > 0 && k[0] > 235 && k[1] > 235 && k[2] > 235; });
        var tr = tone.rgb[0], tg = tone.rgb[1], tb = tone.rgb[2];
        for (var i = 0; i < px.length; i += 4) {
          if (px[i + 3] < 250) continue;   // transparent or translucent (soft shadow / gradient overlay): leave as is
          var r = px[i], g = px[i + 1], b = px[i + 2], sat = Math.max(r, g, b) - Math.min(r, g, b);
          if (white && Math.min(r, g, b) > 200 && sat < 14) continue;   // backdrop incl. its soft grey fade
          var l = (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255;
          l = Math.pow(l, tone.gamma); l = Math.min(1, Math.max(0, (l - 0.5) * tone.contrast + 0.5));
          var spec = l > 0.8 ? ((l - 0.8) / 0.2) * tone.specular : 0;
          px[i] = Math.round(tr * l + (255 - tr * l) * spec); px[i + 1] = Math.round(tg * l + (255 - tg * l) * spec); px[i + 2] = Math.round(tb * l + (255 - tb * l) * spec);
        }
        ctx.putImageData(d, 0, 0);
        cache[key] = c.toDataURL('image/png'); cb(cache[key]);
      } catch (e) { cache[key] = null; cb(null); }   // tainted canvas (no CORS) -> no preview
    };
    im.src = src;
  }

  // ---- picker --------------------------------------------------------------------
  var finish = null, cap = null;
  var rendered = {}; variants.forEach(function (v) { rendered[v.finish] = true; });
  var finishes = STANDARD.slice();
  variants.forEach(function (v) { if (finishes.indexOf(v.finish) < 0) finishes.push(v.finish); });
  var caps = []; variants.forEach(function (v) { if (v.cap && caps.indexOf(v.cap) < 0) caps.push(v.cap); });

  var chips = root.querySelector('[data-rq-finish-chips]'), capBox = root.querySelector('[data-rq-caps]'), capChips = root.querySelector('[data-rq-cap-chips]');
  var hint = root.querySelector('[data-rq-hint]'), note = root.querySelector('[data-rq-finish-note]');
  var finishSelect = root.querySelector('[data-rq-finish-select]'), capSelect = root.querySelector('[data-rq-cap-select]'), colorRow = root.querySelector('[data-rq-color-row]');
  var nRendered = Object.keys(rendered).length;
  note.textContent = (nRendered ? nRendered + ' with photo preview, ' : '') + 'any colour available';

  function chip(label, pressed, swatch) {
    var b = document.createElement('button'); b.type = 'button'; b.className = 'rq__chip'; b.setAttribute('aria-pressed', pressed ? 'true' : 'false');
    if (swatch) { var s = document.createElement('span'); s.className = 'rq__swatch'; s.style.background = swatch; b.appendChild(s); }
    b.appendChild(document.createTextNode(label)); return b;
  }
  function currentVariant() {
    if (!finish) return null;
    var vs = variants.filter(function (v) { return v.finish === finish; }); if (!vs.length) return null;
    return vs.filter(function (v) { return !cap || v.cap === cap; })[0] || vs[0];
  }
  function render() {
    chips.innerHTML = ''; var all = chip('Catalog photo', finish === null); all.onclick = function () { pick(null); }; chips.appendChild(all);
    finishes.forEach(function (f) {
      var b = chip(f, finish === f, SWATCH[f]); b.title = rendered[f] ? f + ' - photo preview' : f + ' - approximate preview';
      b.onclick = function () { pick(f); }; chips.appendChild(b);
    });
    var v = currentVariant();
    capBox.hidden = !(finish && caps.length > 1 && variants.some(function (x) { return x.finish === finish && x.cap; }));
    capChips.innerHTML = '';
    caps.forEach(function (c) { var b = chip(c, cap === c); b.onclick = function () { cap = c; capSelect.value = c; render(); }; capChips.appendChild(b); });
    if (!finish) { restoreImage(); hint.hidden = true; return; }
    if (v) { swapImage(v.url, finish + (v.cap ? ' · ' + v.cap : '')); hint.hidden = true; return; }
    hint.hidden = false; hint.textContent = finish + ': built to order. Generating an approximate preview…';
    var f = finish;
    var tryCdn = function (src, next) { approx(src, f, function (url) { if (finish !== f) return; if (url) { swapImage(url, f + ': approximate preview'); hint.textContent = 'Approximate preview: the catalog photo re-coloured, not a factory render.'; } else if (next) next(); else { restoreImage(); hint.textContent = f + ': built to order, photo preview coming.'; } }); };
    // Prefer the Cloudinary copy: CORS-enabled and keeps the transparent backdrop; Shopify's CDN copy is the fallback.
    var cdn = root.dataset.imageCdn;
    if (cdn) tryCdn(cdn, function () { tryCdn(catalogImage, null); }); else tryCdn(catalogImage, null);
  }
  function pick(f) {
    finish = f;
    if (f && caps.length && !cap) { var v = variants.filter(function (x) { return x.finish === f && x.cap; })[0]; cap = v ? v.cap : null; if (cap) capSelect.value = cap; }
    if (f) { finishSelect.value = STANDARD.indexOf(f) >= 0 ? f : 'Color match / custom'; if (STANDARD.indexOf(f) < 0) root.querySelector('[name=colorCode]').value = f; finishSelect.dispatchEvent(new Event('change')); }
    render();
  }
  finishSelect.addEventListener('change', function () { colorRow.hidden = finishSelect.value !== 'Color match / custom'; });
  render();

  // ---- vehicle photos --------------------------------------------------------------
  if (vehicles.length) {
    var grid = root.querySelector('[data-rq-vehicle-grid]'), g = grid.querySelector('.rq__vgrid');
    vehicles.forEach(function (v) { var a = document.createElement('a'); a.href = v.url; a.target = '_blank'; a.rel = 'noopener'; var im = document.createElement('img'); im.src = v.url; im.alt = wheelName + ' on ' + v.vehicle; im.loading = 'lazy'; a.appendChild(im); a.appendChild(document.createTextNode(v.vehicle)); g.appendChild(a); });
    grid.hidden = false;
  }

  // ---- form -------------------------------------------------------------------------
  var form = root.querySelector('[data-rq-form]'), err = root.querySelector('[data-rq-error]'), done = root.querySelector('[data-rq-done]'), submit = root.querySelector('[data-rq-submit]');
  var openBtn = root.querySelector('[data-rq-open]');
  openBtn.addEventListener('click', function () {
    openBtn.hidden = true; form.hidden = false;
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var first = form.querySelector('input[name=name]'); if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 400);
  });
  var years = root.querySelector('[data-rq-years]'), y0 = new Date().getFullYear();
  for (var y = y0 + 1; y >= y0 - 35; y--) { var o = document.createElement('option'); o.value = o.textContent = String(y); years.appendChild(o); }
  // Pre-fill from the wheel finder's saved vehicle
  try {
    var ymm = JSON.parse(localStorage.getItem('ymm') || 'null');
    if (ymm && ymm.y) { years.value = String(ymm.y); form.vehicleMake.value = ymm.mk || ''; form.vehicleModel.value = ((ymm.mo || '') + (ymm.sb ? ' ' + ymm.sb : '')).trim(); }
  } catch (e) {}

  function validName(n) { n = n.trim(); return n.length >= 5 && /^[a-zA-ZÀ-ÖØ-öø-ÿ'\-]+(\s+[a-zA-ZÀ-ÖØ-öø-ÿ'\-]+)+$/.test(n); }
  function validPhone(p) { return p.replace(/\D/g, '').length >= 10; }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (form.website.value) { form.hidden = true; done.hidden = false; return; }     // honeypot
    var f = form, problems = [];
    if (!validName(f.name.value)) problems.push('Enter your first and last name.');
    if (!/^\S+@\S+\.\S+$/.test(f.email.value)) problems.push('Enter a valid email.');
    if (!validPhone(f.phone.value)) problems.push('Enter a valid 10-digit phone number.');
    if (!f.vehicleYear.value || !f.vehicleMake.value.trim() || !f.vehicleModel.value.trim()) problems.push('Tell us your vehicle year, make and model.');
    if (!f.sizePreference.value) problems.push('Pick a size.');
    if (!f.finishPreference.value) problems.push('Pick a finish.');
    if (problems.length) { err.hidden = false; err.textContent = problems.join(' '); return; }
    err.hidden = true; submit.disabled = true; submit.textContent = 'Sending…';
    var payload = {
      wheelName: wheelName, wheelImageUrl: root.dataset.imageCdn || catalogImage, source: 'shopify', productUrl: location.href.split('?')[0],
      name: f.name.value.trim(), email: f.email.value.trim(), phone: f.phone.value.trim(),
      vehicleYear: f.vehicleYear.value, vehicleMake: f.vehicleMake.value.trim(), vehicleModel: f.vehicleModel.value.trim(),
      sizePreference: f.sizePreference.value, finishPreference: f.finishPreference.value, colorCode: f.colorCode.value.trim(),
      centerCap: f.centerCap.value, staggered: f.staggered.value, bigBrakes: f.bigBrakes.value, needTires: f.needTires.value, message: f.message.value.trim()
    };
    fetch(api, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); form.hidden = true; done.hidden = false; })
      .catch(function () { err.hidden = false; err.textContent = 'Something went wrong sending your request. Please call 205-644-1082 or try again.'; submit.disabled = false; submit.textContent = 'Send quote request'; });
  });
})();
